export const HEALTH_AND_SAFETY_SESSION_KEY = "vr-health-and-safety-shown";

interface StorageWhitelistItem {
  key: string;
  shouldPreserve?: (value: string) => boolean;
}

const SESSION_STORAGE_WHITELIST: readonly StorageWhitelistItem[] = [
  { key: HEALTH_AND_SAFETY_SESSION_KEY, shouldPreserve: value => value === "true" },
];

const LOCAL_STORAGE_WHITELIST: readonly StorageWhitelistItem[] = [];

const clearStorageExcept = (storage: Storage, whitelist: readonly StorageWhitelistItem[]): void => {
  const preservedItems: [string, string][] = [];
  for (const { key, shouldPreserve } of whitelist) {
    const value = storage.getItem(key);
    if (value !== null && (!shouldPreserve || shouldPreserve(value))) {
      preservedItems.push([key, value]);
    }
  }

  storage.clear();
  for (const [key, value] of preservedItems) {
    storage.setItem(key, value);
  }
};

export const clearAuthSessionStorage = ({ preserveLocale = false } = {}) => {
  const whitelist = [...SESSION_STORAGE_WHITELIST];
  if (preserveLocale) {
    whitelist.push({ key: "temp_language_preference", shouldPreserve: value => Boolean(value) });
  }
  clearStorageExcept(window.sessionStorage, whitelist);
};

export const clearAuthLocalStorage = () => {
  clearStorageExcept(window.localStorage, LOCAL_STORAGE_WHITELIST);
};
